import { render } from "./DonationsTab.vue?vue&type=template&id=d6d9c42e"
import script from "./DonationsTab.vue?vue&type=script&lang=js"
export * from "./DonationsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__